module.exports = __webpack_public_path__ + "static/github-d22ee3727a7216019c3848df6eafa024.png";